import {
  createContext,
  FC,
  PropsWithChildren,
  useContext,
  useMemo,
  useState,
} from 'react';
import { ClassifierFormDataType } from '@atlas-frontend/sdk';

interface ClassifierMappingContextValue {
  classifierFrom: ClassifierFormDataType | undefined;
  setClassifierFrom: (classifier: ClassifierFormDataType) => void;
  classifierTo: ClassifierFormDataType | undefined;
  setClassifierTo: (classifier: ClassifierFormDataType) => void;
}

/* eslint-disable @typescript-eslint/no-empty-function */
const noop = () => {};

const ClassifierMappingContext = createContext<ClassifierMappingContextValue>({
  classifierFrom: undefined,
  setClassifierFrom: noop,
  classifierTo: undefined,
  setClassifierTo: noop,
});

export const useClassifierMappingContext = () =>
  useContext(ClassifierMappingContext);

export const ClassifierMappingContextProvider: FC<PropsWithChildren> = (
  props
) => {
  const { children } = props;

  const [classifierFrom, setClassifierFrom] =
    useState<ClassifierFormDataType>();
  const [classifierTo, setClassifierTo] = useState<ClassifierFormDataType>();

  const value = useMemo(
    () => ({
      classifierFrom,
      setClassifierFrom,
      classifierTo,
      setClassifierTo,
    }),
    [classifierFrom, classifierTo]
  );

  return (
    <ClassifierMappingContext.Provider value={value}>
      {children}
    </ClassifierMappingContext.Provider>
  );
};
